import DateFormatter from 'components/DateFormatter';
import { currencyToLocal, INVOICE_STATUS } from 'utils/constants';

/* eslint-disable react/react-in-jsx-scope */
export const invoicesColumns = [
  { accessorKey: 'name', header: 'CATEGORY', enableSorting: true },
  { accessorKey: 'created', header: 'CREATED ON', enableSorting: true },
  { accessorKey: 'status', header: 'STATUS', enableSorting: true },
];

export const invoicesCategoryColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },

  {
    accessorFn: (row) => {
      return <div className="mb-1">{row?.order?.buyer?.tradeName}</div>;
    },
    header: 'BILLED TO',
    id: 'order.buyer.tradeName',
    enableSorting: false,
    cell: (info) => info.getValue(),
  },
  { accessorKey: 'id', header: 'INVOICE ID', enableSorting: true },
  {
    accessorKey: 'invoiceStatus',
    header: 'PAYMENT',
    cell: ({ row }) => (
      <div>{INVOICE_STATUS?.[row?.original?.invoiceStatus]}</div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'total',
    header: 'AMOUNT',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(
          row?.original?.total,
          row?.original?.rateUnit?.isoCurrencyCode,
        )}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'createdAt',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    header: 'DATE',
    enableSorting: true,
  },
  {
    accessorKey: 'createdByUserId',
    header: 'Created User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'updatedByUserId',
    header: 'Updated User ID',
    enableSorting: true,
  },
];

export const INVOICE_HEADING = {
  ALL: 'All',
  UNPAID: 'Unpaid',
  PARTIALLYPAID: 'Partially paid',
  FULLYPAID: 'Fully paid',
};
